module.exports = __webpack_public_path__ + "img/42_38.3e8d31f2.png";